import React from "react";
import styled from "styled-components";
import { BiSearch } from "react-icons/bi";

const Container = styled.div`
  margin-top: 20px;
  position: relative;
  width: 100%;
  box-shadow: ${(props) => props.theme["lm-shadow-active"]};
  border-radius: 10px;
`;

const TextInput = styled.input.attrs({ type: "search" })`
  padding: 20px 20px 20px 40px;
  width: 100%;
  border-radius: inherit;
  outline: none;
  border: none;
  background-color: ${(props) => props.theme["lm-bg-content"]};
  color: ${(props) => props.theme["lm-text"]};
  font-size: 18px;
  font-weight: 500;

  &::placeholder {
    color: ${(props) => props.theme["lm-text"]};
    font-family: "Sapce Mono", monospace;
    font-size: 18px;
  }

  @media only screen and (max-width: 768px) {
    font-size: 12px;
    &::placeholder {
      font-size: 11px;
    }
  }
`;

const SearchIcon = styled(BiSearch)`
  color: #0079ff;
  position: absolute;
  font-size: 26px;
  font-weight: 600;
  top: 18px;
  left: 10px;
`;

const SearchButton = styled.button`
  position: absolute;
  color: white;
  background-color: ${(props) => props.theme["btn"]};
  border: none;
  outline: none;
  border-radius: 10px;
  padding: 15px 20px;
  top: 7px;
  right: 10px;

  &:hover {
    background-color: ${(props) => props.theme["btn-hover"]};
  }
`;

const SearchBar = ({ handleSearch, setQuery }) => {
  return (
    <Container>
      <SearchIcon />
      <TextInput
        placeholder="Search Github username..."
        onChange={(e) => setQuery(e.target.value)}
      />
      <SearchButton onClick={handleSearch}>Search</SearchButton>
    </Container>
  );
};

export default SearchBar;
